import React, { useState } from "react";
import styles from "./drawer.module.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setVisible } from "../../../store/slices/drawer";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router";
import ChangeLanguageModal from "../../modal/changeLanguage";
import useInstallApp from "../../../hooks/useInstallApp";

import {
  IoClose,
  IoArrowRedoOutline,
  IoPersonCircleOutline,
  IoCard,
} from "react-icons/io5";
import { MdEdit, MdLogout, MdMail, MdDownload } from "react-icons/md";
import { AiFillCrown } from "react-icons/ai";

function Item({ Icon, label, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center pt-3 pb-3 w-full touchable-opacity"
    >
      <div className="w-[28px]">
        <Icon size={28} />
      </div>
      <span className="ml-3 text-left">{label}</span>
    </button>
  );
}

export default function Drawer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showInstall, promptInstall } = useInstallApp();
  const [language, setLaguage] = useState(false);
  const visible = useSelector((state) => state.drawer.visible);
  const { t } = useTranslation();
  const { user, signOut } = useAuth();

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleNavigate = (path) => {
    handleClose();
    setTimeout(() => {
      navigate(path);
    }, 500);
  };

  const handleLogout = () => {
    handleClose();
    setTimeout(() => {
      signOut();
    }, 500);
  };

  const handlePlayers = () => {
    handleClose();
    setTimeout(() => {
      navigate("/users");
    }, 500);
  };

  const handleShare = () => {
    navigator.share({
      title: t("nomeJogo1"),
      url: "https://loverschallenge.com/",
    });
  };

  const handleLanguage = () => {
    setLaguage(true);
  };

  const handleContact = () => {
    window.location.href = `mailto:dev12br@gmail.com?subject=${t(
      "duvidas"
    )}&body=${t("description")}`;
  };

  const handlePortal = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/payment/portal/${user.id_usuario}`;
  };

  const handleInstall = () => {
    promptInstall();
  };

  return (
    <div
      id="drawer"
      className={`${styles.container} no-print ${
        visible ? styles.visible : styles["not-visible"]
      }`}
    >
      <div onClick={handleClose} className={styles.window}></div>
      <div className={styles.menu}>
        <div className="flex items-center justify-end">
          <button
            className="p-1 touchable-opacity"
            type="button"
            onClick={handleClose}
          >
            <IoClose size={32} />
          </button>
        </div>
        <div className="flex-1">
          {!user?.isPremium ? (
            <Item
              Icon={AiFillCrown}
              onClick={() => {
                handleNavigate("/premium");
              }}
              label={t("version")}
            />
          ) : null}
          {user?.stripe_customer_id ? (
            <Item
              Icon={IoCard}
              onClick={handlePortal}
              label={t("customerPortal")}
            />
          ) : null}
          <Item
            Icon={MdEdit}
            onClick={() => {
              handleNavigate(
                user?.isPremium
                  ? "/hot-challenges/player-categories"
                  : "/premium"
              );
            }}
            label={t("createMyChallenges")}
          />
          <Item
            Icon={IoPersonCircleOutline}
            label={t("players")}
            onClick={handlePlayers}
          />
          <Item
            Icon={() => <span className="text-[22px]">{t("bandeira")}</span>}
            label={t("languages")}
            onClick={handleLanguage}
          />
          <Item Icon={MdMail} label={t("contact")} onClick={handleContact} />
          {navigator.share ? (
            <Item
              Icon={IoArrowRedoOutline}
              label={t("share")}
              onClick={handleShare}
            />
          ) : null}
          {showInstall ? (
            <Item
              Icon={MdDownload}
              label={t("installApp")}
              onClick={handleInstall}
            />
          ) : null}
        </div>
        <div className="">
          <Item Icon={MdLogout} label={t("logout")} onClick={handleLogout} />
        </div>
      </div>
      <ChangeLanguageModal visible={language} setVisible={setLaguage} />
    </div>
  );
}
